import state from './Storage/states'
import mutations from './Storage/mutations'
import actions from './Storage/actions'
import getters from './Storage/getters'

// 共通
const Store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default Store
